import './style.scss';
import { useHistory } from 'react-router-dom';
import { IProjectDocInfoMenu } from '../../../../model/api-modules/document';
import getStartedIcon from '../../../../assets/svg/get-started-icon.svg';
import portalManualIcon from '../../../../assets/svg/portal-manual-icon.svg';
import serviceManualIcon from '../../../../assets/svg/service-manual-icon.svg';
import demoTutorialIcon from '../../../../assets/svg/demo-tutorial-icon.svg';
import SDKToolsIcon from '../../../../assets/svg/sdk-tools-icon.svg';
import knowledgeBaseIcon from '../../../../assets/svg/knowledge-base-icon.svg';
import updateHistoryIcon from '../../../../assets/svg/update-history-icon.svg';
import documentRightIcon from '../../../../assets/svg/document-right-icon.svg';
import { LanguageType } from '../../../../lib';
// import getFormatMessage from '../../../../locales/get-format-message';

interface IProps {
  readonly menu: IProjectDocInfoMenu;
  readonly isDocPublicRoute: boolean;
  readonly lang: LanguageType;
}
export const HomeRightItem = (props: IProps) => {
  const history = useHistory();
  let icon = '';
  // let text = '';
  switch (props.menu?.name) {
    case 'Get Started':
    case '入门指南':
      icon = getStartedIcon;
      // text = getFormatMessage('get_started_des', {}, props.lang);
      break;
    case 'Portal Manual':
    case '开发者门户使用手册':
      icon = portalManualIcon;
      // text = getFormatMessage('portal_manual_des', {}, props.lang);
      break;
    case 'Services Manual':
    case '服务使用手册':
      icon = serviceManualIcon;
      // text = getFormatMessage('services_manual_des', {}, props.lang);
      break;
    case 'Demo Tutorials':
    case 'Demo使用指南':
      icon = demoTutorialIcon;
      // text = getFormatMessage('demo_tutorials_des', {}, props.lang);
      break;
    case 'Tools Manual':
    case '工具使用手册':
      icon = SDKToolsIcon;
      // text = getFormatMessage('tools_manual_des', {}, props.lang);
      break;
    case 'Knowledge Base':
    case '知识库':
      icon = knowledgeBaseIcon;
      // text = getFormatMessage('knowledge_base_des', {}, props.lang);
      break;
    case 'Update History':
    case '版本说明':
      icon = updateHistoryIcon;
      // text = getFormatMessage('update_history_des', {}, props.lang);
      break;
    default:
      icon = getStartedIcon;
  }

  const joinPath = (
    projectId: string | number | undefined,
    docId?: string | number
  ) => {
    const url = props.isDocPublicRoute ? '/doc-public' : '/doc';
    if (!projectId) return;
    if (docId) {
      history.push(`${url}/detail/${projectId}/${docId}`);
      return;
    }
    history.push(`${url}/detail/${projectId}`);
  };

  const renderItemMenu = () => {
    if (props.menu.nodes && props.menu.nodes.length !== 0) {
      if (
        props.menu.name === 'Update History' ||
        props.menu.name === '版本说明'
      ) {
        return (
          <div className="right-item-menu">
            <div
              onClick={() =>
                joinPath(props.menu.nodes[0].project_id, props.menu.nodes[0].id)
              }
              className="right-item-menu-item"
            >
              {props.menu.nodes[0].name}
            </div>
          </div>
        );
      }
      return (
        <div className="right-item-menu">
          {props.menu.nodes.map((item) => {
            return (
              <div
                onClick={() => joinPath(item.project_id, item.id)}
                className="right-item-menu-item"
              >
                {item.name}
              </div>
            );
          })}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="home-right-item">
      <div className="right-item-name-box">
        <img src={icon} className="right-item-icon" />
        <div
          className="right-item-name"
          onClick={() => joinPath(props.menu?.project_id, props.menu?.id)}
        >
          {props.menu.name}
        </div>
        <img src={documentRightIcon} className="right-item-right-icon" />
      </div>
      {/* <div className="right-item-text">{text}</div> */}
      {renderItemMenu()}
    </div>
  );
};
